__turbopack_context__.v({
  "policy_togglebtn_wrapper": "AZiwNq_policy_togglebtn_wrapper",
  "toggle_btn": "AZiwNq_toggle_btn",
  "trip_toggle_sts": "AZiwNq_trip_toggle_sts",
});
